module.exports = __webpack_public_path__ + "static/media/banner-left.44ff71f9.svg";